/**
 * @generated SignedSource<<d5103548417a8abed49684b48c9b5ecb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type SquareLoyaltyRewardStatus = "DELETED" | "ISSUED" | "REDEEMED";
import { FragmentRefs } from "relay-runtime";
export type BookingLoyaltyRewards_booking$data = {
  readonly id: string;
  readonly patronOrders?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly availableLoyaltyRewards?: {
          readonly balance: number;
        } | null | undefined;
        readonly loyaltyEnrollmentOffer?: {
          readonly points: number;
        } | null | undefined;
        readonly squareLoyaltyRewards?: ReadonlyArray<{
          readonly id: string;
          readonly loyaltyAccount: {
            readonly id: string;
          } | null | undefined;
          readonly loyaltyCustomerId: string | null | undefined;
          readonly points: number;
          readonly rewardTier: {
            readonly id: string;
            readonly name: string;
          };
          readonly status: SquareLoyaltyRewardStatus;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"PatronCheckoutLoyaltyRewardsEnrollmentOffer_order" | "PatronCheckoutLoyaltyRewards_order">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentType": "BookingLoyaltyRewards_booking";
};
export type BookingLoyaltyRewards_booking$key = {
  readonly " $data"?: BookingLoyaltyRewards_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingLoyaltyRewards_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "alias": "patronOrders",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "OrderConnection",
    "kind": "LinkedField",
    "name": "orders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrderEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Order",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "condition": "patronLoyalty",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderAvailableLoyaltyRewards",
                    "kind": "LinkedField",
                    "name": "availableLoyaltyRewards",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "balance",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderLoyaltyEnrollmentOffer",
                    "kind": "LinkedField",
                    "name": "loyaltyEnrollmentOffer",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SquareLoyaltyReward",
                    "kind": "LinkedField",
                    "name": "squareLoyaltyRewards",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v2/*: any*/),
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "loyaltyCustomerId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareLoyaltyAccount",
                        "kind": "LinkedField",
                        "name": "loyaltyAccount",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareLoyaltyRewardTier",
                        "kind": "LinkedField",
                        "name": "rewardTier",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PatronCheckoutLoyaltyRewards_order"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PatronCheckoutLoyaltyRewardsEnrollmentOffer_order"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "orders(first:1)"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingLoyaltyRewards_booking",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "a9226c6d6ba00d4e188a9d5db39e65d4";

export default node;
